/**
 * Seed demo data for a club. Run from browser console or a temp component.
 * Usage: import { seedDemoData } from './utils/seedDemoData'; seedDemoData();
 */
import { db } from '../firebase';
import {
  doc,
  setDoc,
  addDoc,
  collection,
  serverTimestamp,
} from 'firebase/firestore';

const CLUB_ID = 'FQcb7CLOea9YrziY5yIR';

const FIRST_NAMES = [
  'Emma', 'Olivia', 'Ava', 'Sophia', 'Isabella', 'Mia', 'Charlotte', 'Amelia',
  'Harper', 'Evelyn', 'Abigail', 'Emily', 'Ella', 'Elizabeth', 'Camila', 'Luna',
  'Sofia', 'Avery', 'Mila', 'Aria', 'Scarlett', 'Penelope', 'Layla', 'Chloe',
  'Victoria', 'Madison', 'Eleanor', 'Grace', 'Nora', 'Riley', 'Zoey', 'Hannah',
  'Hazel', 'Lily', 'Ellie', 'Violet', 'Lillian', 'Zoe', 'Stella', 'Aurora',
];

const LAST_NAMES = [
  'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis',
  'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson',
  'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson',
  'White', 'Harris', 'Sanchez', 'Clark', 'Ramirez', 'Lewis', 'Robinson',
];

function randomItem(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randomBirthdate(ageGroupLabel) {
  const num = parseInt(ageGroupLabel.replace('U', ''), 10);
  const currentYear = new Date().getFullYear();
  const birthYear = currentYear - num + Math.floor(Math.random() * 2);
  const month = Math.floor(Math.random() * 12) + 1;
  const day = Math.floor(Math.random() * 28) + 1;
  return `${birthYear}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

function generateId() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';
  for (let i = 0; i < 20; i++) id += chars.charAt(Math.floor(Math.random() * chars.length));
  return id;
}

export async function seedDemoData() {
  console.log('[seedDemoData] Starting...');

  const ageGroups = ['12U', '13U', '14U', '15U', '16U'];
  const playersPerGroup = { '12U': 6, '13U': 8, '14U': 10, '15U': 7, '16U': 5 };

  const usedNames = new Set();
  let totalCreated = 0;

  for (const ag of ageGroups) {
    const count = playersPerGroup[ag];
    for (let i = 0; i < count; i++) {
      let firstName, lastName, fullName;
      do {
        firstName = randomItem(FIRST_NAMES);
        lastName = randomItem(LAST_NAMES);
        fullName = `${firstName} ${lastName}`;
      } while (usedNames.has(fullName));
      usedNames.add(fullName);

      const fakeUserId = `demo_${generateId()}`;
      const birthdate = randomBirthdate(ag);

      await setDoc(doc(db, 'users', fakeUserId), {
        firstName,
        lastName,
        email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@demo.com`,
        birthdate,
        onboardingComplete: true,
        termsAccepted: true,
        liabilityWaiverAccepted: true,
        createdAt: serverTimestamp(),
        isDemo: true,
      });

      await addDoc(collection(db, 'club_memberships'), {
        userId: fakeUserId,
        clubId: CLUB_ID,
        year: new Date().getFullYear(),
        status: 'active',
        stripeSubscriptionId: null,
        joinedAt: serverTimestamp(),
        expiresAt: `${new Date().getFullYear()}-12-31`,
        isDemo: true,
      });

      totalCreated++;
    }
  }

  console.log(`[seedDemoData] Created ${totalCreated} demo players`);

  // Monthly stats for charts (last 6 months of growth)
  const now = new Date();
  const monthlyData = [];
  for (let i = 5; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const monthStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const members = Math.round(totalCreated * ((6 - i) / 6) * (0.8 + Math.random() * 0.4));
    monthlyData.push({ month: monthStr, totalMembers: Math.min(members, totalCreated) });
  }

  for (const stat of monthlyData) {
    await setDoc(doc(db, 'clubs', CLUB_ID, 'monthlyStats', stat.month), {
      month: stat.month,
      totalMembers: stat.totalMembers,
      isDemo: true,
    });
  }

  console.log(`[seedDemoData] Created ${monthlyData.length} monthly stats entries`);
  console.log('[seedDemoData] Done!');
  return { playersCreated: totalCreated, monthlyStats: monthlyData.length };
}
